module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-coins-xxs-fb4ad03bbb71d44d97ab407b8098e993.svg";